/**
 *
 * https://github.com/facebook/react/blob/main/packages/react-reconciler/README.md
 *
 * Tutorials:
 *
 * https://agent-hunt.medium.com/introduction-to-react-native-renderers-aka-react-native-is-the-java-and-react-native-renderers-are-828a0022f433
 * https://github.com/acdlite/react-fiber-architecture
 *
 * Example of HostConfigs:
 *
 * https://github.com/facebook/react/blob/main/packages/react-reconciler/src/forks/ReactFiberConfig.custom.js
 * https://github.com/facebook/react/blob/main/packages/react-dom-bindings/src/client/ReactFiberConfigDOM.js
 * https://github.com/facebook/react/blob/main/packages/react-native-renderer/src/ReactFiberConfigNative.js
 * https://github.com/facebook/react/blob/main/packages/react-art/src/ReactFiberConfigART.js
 *
 * https://github.com/pmndrs/react-three-fiber/blob/master/packages/fiber/src/core/renderer.ts
 *
 * https://github.com/agenthunt/hello-react-custom-renderer/blob/master/src/myCustomRenderer.js
 *
 * https://github.com/ReactUnity/renderer/blob/main/src/renderer/async/reconciler.ts
 * https://github.com/ReactUnity/renderer/blob/main/src/renderer/sync/reconciler.ts
 **/

import { EventEmitter } from 'events';
import { ConcurrentRoot } from 'react-reconciler/constants.js';

import { createContainer, updateContainer } from './reconciler/index.js';
import { Container } from './types.js';

export { extend } from './reconciler/index.js';

export class GraphRenderer extends EventEmitter<{
  hydrate: [];
  delete: [];
}> {
  container: any;
  constructor(node: Container) {
    super();
    const logRecoverableError =
      typeof reportError === 'function'
        ? // In modern browsers, reportError will dispatch an error event,
          // emulating an uncaught JavaScript error.
          reportError
        : // In older browsers and test environments, fallback to console.error.
          console.error;

    this.container = createContainer(
      node,
      ConcurrentRoot,
      null,
      false,
      null,
      'spz',
      logRecoverableError,
      null
    );
  }
  render = (children: React.ReactNode, cb?: () => void) => {
    updateContainer(children, this.container, null, cb);
  };

  unmount = () => {
    updateContainer(null, this.container, null);
  };
}

// https://github.com/facebook/react/blob/e2b93afc604f857f7b59788920533ff7d1c72563/packages/react-dom/src/client/ReactDOMRoot.js#L162
export const createRoot = (node: Container) => {
  return new GraphRenderer(node);
};
